/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sync_Vekn_Tournaments_ConfirmInputs */



/**
* | output |
* | --- |
* | "Trigger a VEKN tournament sync now?" |
*
* @param {Admin_Sync_Vekn_Tournaments_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_sync_vekn_tournaments_confirm = /** @type {((inputs?: Admin_Sync_Vekn_Tournaments_ConfirmInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sync_Vekn_Tournaments_ConfirmInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déclencher une synchronisation des tournois VEKN maintenant ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Activar una sincronización de torneos de VEKN ahora?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Disparar uma sincronização de torneios do VEKN agora?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avviare una sincronizzazione dei tornei VEKN ora?")
	return /** @type {LocalizedString} */ ("Trigger a VEKN tournament sync now?")
});